// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z6ec","badges":"styles_badges__1xfB3"};